export default __webpack_public_path__ + "static/media/upArrow.1bf87d9c.svg";